import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { HeartHandshake } from "lucide-react";

const tc = (s) => (s || "").toLowerCase().replace(/(^|\s|')\S/g, (m) => m.toUpperCase());
const d = (v) => (v ? new Date(v).toLocaleDateString("it-IT") : "");

// Badge «Iscritto RUNTS» (verde) o «Non più iscritto» (rosso). Usa i dati già presenti (runts) oppure li chiede per codice fiscale.
export function RuntsBadge({ runts, cf, testid = "runts-badge" }) {
  const [r, setR] = useState(runts || null);
  useEffect(() => {
    if (runts) { setR(runts); return; }
    if (!cf || cf.trim().length < 11) { setR(null); return; }
    api.get(`/runts/badge/${encodeURIComponent(cf.trim())}`).then(({ data }) => setR(data.iscritto === null ? null : data)).catch(() => setR(null));
  }, [runts, cf]);
  if (!r || r.iscritto === undefined) return null;
  if (r.iscritto) return (
    <span className="inline-flex items-center gap-1 text-[11px] px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-800 border border-emerald-200" data-testid={testid}
      title="Registro Unico Nazionale del Terzo Settore">
      <HeartHandshake className="h-3 w-3" /> Iscritto RUNTS · {tc(r.sezione)}{r.data_iscrizione && ` · dal ${r.data_iscrizione}`}
    </span>
  );
  return (
    <span className="inline-flex items-center gap-1 text-[11px] px-2 py-0.5 rounded-full bg-red-50 text-red-700 border border-red-200" data-testid={`${testid}-uscito`}>
      <HeartHandshake className="h-3 w-3" /> Non più iscritto al RUNTS{r.uscito_at && ` dal ${d(r.uscito_at)}`}
    </span>
  );
}
